import {
    fetchUser, removeUser as removeEntity,
    forceUserPassword as forceEntityPassword,
    fetchUserPurchases,
    updateUser,
} from '../../entities/user';

export const scope = 'USER_SUPPORT';
export const REFRESH_USER_SUPPORT = 'REFRESH_USER_SUPPORT';

export function fetchUserIfNeeded(payload) {
    return (dispatch, getState) => {
        const { user } = getState().app.support;

        if (!user.info.isFetching)
            dispatch(fetchUser(payload, scope));
    };
}

export function removeUser(payload) {
    return dispatch => {
        dispatch(removeEntity(payload, scope));
    };
}

export function forceUserPassword(payload) {
    return dispatch => {
        dispatch(forceEntityPassword(payload, scope));
    };
}

export function updateUserOptIn(payload) {
    return dispatch => {
        dispatch(updateUser(payload, scope));
    };
}

export function refreshUserSupport() {
    return {
        type: REFRESH_USER_SUPPORT,
        scope
    };
}

export function fetchPurchases(payload, onSuccess, onError) {
    return (dispatch) => {
        dispatch(fetchUserPurchases(payload, scope, onSuccess, onError));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/support/user.js